import { render, staticRenderFns } from "./AlterarSenhaExterno.vue?vue&type=template&id=a96aeba6"
import script from "./AlterarSenhaExterno.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaExterno.vue?vue&type=script&lang=js"
import style0 from "./AlterarSenhaExterno.vue?vue&type=style&index=0&id=a96aeba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports